export enum JobAttachmentPurposeType {
    Creation = 0,
    Completion = 1,
    ProofOfWork = 2,
}